import { createContext } from 'react';
import type { DocType } from '@/api/docs';

export interface DocViewerContextValue {
  open: (type: DocType, id: number, docNo?: string, partyPhone?: string) => void;
}

export const DocViewerContext = createContext<DocViewerContextValue | undefined>(undefined);
